// src/data/BookDB.js
const books = [
  {
    id: 1,
    title: 'Atomic Habits',
    author: 'James Clear',
    category: 'Daily Life',
    image: 'https://m.media-amazon.com/images/I/91bYsX41DVL._AC_UF1000,1000_QL80_.jpg',
    description: 'A practical guide to building habits that stick and transform your life.',
    pages: 320,
    price: 699,
    offer: 420,
    rating: 4.7,
    reviewsCount: 4500,
    isFeatured: false,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    { user: 'Aarav',
        comment: 'A powerful story about empathy and justice.',
        likes: 6,
        dislikes: 0,
        date: '2023-10-05',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Sanya',
        comment: 'A thought-provoking read on innovation.',
        likes: 4,
        dislikes: 1,
        date: '2023-10-06',
        helpful: true,
        verifiedPurchase: false
    },
    { user: 'Kunal',
        comment: 'Practical advice for entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-03',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Ritika',
        comment: 'A classic that everyone should read.',
        likes: 7,
        dislikes: 1,
        date: '2023-10-04',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 2,
    title: 'The Alchemist',
    author: 'Paulo Coelho',
    category: 'Fiction',
    image: 'https://m.media-amazon.com/images/I/71aFt4+OTOL.jpg',
    description: 'A fable about following your dreams and listening to your heart.',
    pages: 208,
    price: 499,
    offer: 320,
    rating: 4.5,
    reviewsCount: 8500,
    isFeatured: false,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 3,
    title: 'Ikigai',
    author: 'Francesc Miralles',
    category: 'Daily Life',
    image: 'https://m.media-amazon.com/images/I/71tbalAHYCL.jpg',
    description: 'Discover the Japanese secret to a long and happy life.',
    pages: 208,
    price: 550,
    offer: 350,
    rating: 4.6,
    reviewsCount: 6200,
    isFeatured: false,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 4,
    title: 'Rich Dad Poor Dad',
    author: 'Robert Kiyosaki',
    category: 'Finance',
    image: 'https://m.media-amazon.com/images/I/81BE7eeKzAL.jpg',
    description: 'Learn the importance of financial education and wealth building.',
    pages: 336,
    price: 750,
    offer: 480,
    rating: 4.7,
    reviewsCount: 15000,
    isFeatured: true,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 5,
    title: 'The Psychology of Money',
    author: 'Morgan Housel',
    category: 'Finance',
    image: 'https://m.media-amazon.com/images/I/71g2ednj0JL.jpg',
    description: 'Timeless lessons on wealth, greed, and happiness.',
    pages: 252,
    price: 600,
    offer: 400,
    rating: 4.6,
    reviewsCount: 7200,
    isFeatured: true,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 6,
    title: '1984',
    author: 'George Orwell',
    category: 'Fiction',
    image: 'https://m.media-amazon.com/images/I/71kxa1-0mfL.jpg',
    description: 'A dystopian novel about totalitarianism and surveillance.',
    pages: 328,
    price: 499,
    offer: 340,
    rating: 4.6,
    reviewsCount: 7800,
    isFeatured: false,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 7,
    title: 'Marvel Encyclopedia',
    author: 'DK Publishing',
    category: 'Comics',
    image: 'https://m.media-amazon.com/images/I/81iqZ2HHD-L.jpg',
    description: 'Definitive guide to Marvel superheroes and villains.',
    pages: 448,
    price: 2999,
    offer: 2299,
    rating: 4.8,
    reviewsCount: 1900,
    isFeatured: true,
    isBestseller: false,
    isNewArrival: true,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 8,
    title: 'Batman: Year One',
    author: 'Frank Miller',
    category: 'Comics',
    image: 'https://cdn.kobo.com/book-images/575aebcf-a0d5-48d6-a6f0-bda47b048645/353/569/90/False/batman-an-origin-story.jpg',
    description: 'An origin story of Batman’s early crime-fighting days.',
    pages: 144,
    price: 999,
    offer: 720,
    rating: 4.7,
    reviewsCount: 2300,
    isFeatured: false,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 9,
    title: 'Sapiens',
    author: 'Yuval Noah Harari',
    category: 'History',
    image: 'https://m.media-amazon.com/images/I/713jIoMO3UL.jpg',
    description: 'A brief history of humankind from evolution to today.',
    pages: 498,
    price: 799,
    offer: 550,
    rating: 4.7,
    reviewsCount: 9800,
    isFeatured: true,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 10,
    title: 'Think Like a Monk',
    author: 'Jay Shetty',
    category: 'Self-Help',
    image: 'https://m.media-amazon.com/images/I/81GlTN6QQrL.jpg',
    description: 'Train your mind for peace and purpose every day.',
    pages: 352,
    price: 699,
    offer: 480,
    rating: 4.6,
    reviewsCount: 5100,
    isFeatured: true,
    isBestseller: true,
    isNewArrival: true,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 11,
    title: 'Deep Work',
    author: 'Cal Newport',
    category: 'Productivity',
    image: 'https://m.media-amazon.com/images/I/81JJ7fyyKyS.jpg',
    description: 'Rules for focused success in a distracted world.',
    pages: 304,
    price: 650,
    offer: 430,
    rating: 4.6,
    reviewsCount: 4700,
    isFeatured: true,
    isBestseller: false,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 12,
    title: 'Dune',
    author: 'Frank Herbert',
    category: 'Fiction',
    image: 'https://m.media-amazon.com/images/I/913padSawdL.jpg',
    description: 'Epic science fiction saga set on the desert planet Arrakis.',
    pages: 688,
    price: 799,
    offer: 560,
    rating: 4.5,
    reviewsCount: 6600,
    isFeatured: false,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 13,
    title: 'Start With Why',
    author: 'Simon Sinek',
    category: 'Leadership',
    image: 'https://m.media-amazon.com/images/I/71ha4cV4GqL.jpg',
    description: 'How great leaders inspire action by starting with why.',
    pages: 256,
    price: 599,
    offer: 420,
    rating: 4.5,
    reviewsCount: 3700,
    isFeatured: true,
    isBestseller: false,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 14,
    title: 'Can’t Hurt Me',
    author: 'David Goggins',
    category: 'Self-Help',
    image: 'https://m.media-amazon.com/images/I/81dQwQlmAXL.jpg',
    description: 'Master your mind and defy the odds with resilience.',
    pages: 364,
    price: 749,
    offer: 520,
    rating: 4.8,
    reviewsCount: 6700,
    isFeatured: true,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 15,
    title: 'Becoming',
    author: 'Michelle Obama',
    category: 'Biography',
    image: 'https://m.media-amazon.com/images/I/81h2gWPTYJL.jpg',
    description: 'The deeply personal memoir by the former First Lady.',
    pages: 448,
    price: 999,
    offer: 650,
    rating: 4.7,
    reviewsCount: 8900,
    isFeatured: false,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 16,
    title: 'A Promised Land',
    author: 'Barack Obama',
    category: 'Biography',
    image: 'https://m.media-amazon.com/images/I/91+NBrXG-PL.jpg',
    description: 'A memoir by Barack Obama chronicling his presidency.',
    pages: 768,
    price: 1499,
    offer: 1100,
    rating: 4.8,
    reviewsCount: 6200,
    isFeatured: true,
    isBestseller: false,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 17,
    title: 'The Subtle Art of Not Giving a F*ck',
    author: 'Mark Manson',
    category: 'Self-Help',
    image: 'https://m.media-amazon.com/images/I/71QKQ9mwV7L.jpg',
    description: 'A counterintuitive approach to living a good life.',
    pages: 224,
    price: 550,
    offer: 380,
    rating: 4.4,
    reviewsCount: 9300,
    isFeatured: false,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Riya',
        comment: 'A must-read for aspiring entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-07',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Karan',
        comment: 'Insightful and practical advice.',
        likes: 3,
        dislikes: 1,
        date: '2023-10-08',
        helpful: true,
        verifiedPurchase: false
    },
    ]
  },
  {
    id: 18,
    title: 'Zero to One',
    author: 'Peter Thiel',
    category: 'Business',
    image: 'https://m.media-amazon.com/images/I/71m-MxdJ2WL.jpg',
    description: 'Notes on startups and building the future.',
    pages: 224,
    price: 599,
    offer: 440,
    rating: 4.5,
    reviewsCount: 5500,
    isFeatured: true,
    isBestseller: false,
    isNewArrival: false,
    reviews: [
      { user: 'Aarav',
        comment: 'A powerful story about empathy and justice.',
        likes: 6,
        dislikes: 0,
        date: '2023-10-05',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Sanya',
        comment: 'A thought-provoking read on innovation.',
        likes: 4,
        dislikes: 1,
        date: '2023-10-06',
        helpful: true,
        verifiedPurchase: false
    },
      
    ]
  },
  {
    id: 19,
    title: 'To Kill a Mockingbird',
    author: 'Harper Lee',
    category: 'Fiction',
    image: 'https://m.media-amazon.com/images/I/81gepf1eMqL._AC_UF1000,1000_QL80_.jpg',
    description: 'A novel about racial injustice and moral growth. ',
    pages: 336,
    price: 499,
    offer: 360,
    rating: 4.8,
    reviewsCount: 8200,
    isFeatured: false,
    isBestseller: true,
    isNewArrival: false,
    reviews: [
      { user: 'Kunal',
        comment: 'Practical advice for entrepreneurs.',
        likes: 5,
        dislikes: 0,
        date: '2023-10-03',
        helpful: true,
        verifiedPurchase: true
    },
      { user: 'Ritika',
        comment: 'A classic that everyone should read.',
        likes: 7,
        dislikes: 1,
        date: '2023-10-04',
        helpful: true,
        verifiedPurchase: false
    },
      
      
    ]
  },
  {
    id: 20,
    title: 'The Lean Startup',
    author: 'Eric Ries',
    category: 'Business',
    image: 'https://m.media-amazon.com/images/I/81-QB7nDh4L.jpg',
    description: 'How today’s entrepreneurs use continuous innovation.',
    pages: 336,
    price: 799,
    offer: 580,
    rating: 4.5,
    reviewsCount: 4900,
    isFeatured: true,
    isBestseller: false,
    isNewArrival: true,
    reviews: [
      { user: 'Anirudh',
        comment: 'Changed how I approach startups.',
        likes: 10,
        dislikes: 2,
        date: '2023-10-01',
        helpful: true,
        verifiedPurchase: true,
        rating: 5
    },
      { user: 'Tanvi',
        comment: 'Great insights on building a business.',
        likes: 8,
        dislikes: 1,
        date: '2023-10-02',
        helpful: true,
        verifiedPurchase: false,
        rating: 4

    },
      
    ]
  },
];

export default books;

